<template>
  <div class="LoginContainer">
    <div class="LoginCard">
      <div class="Header">
        <div class="Title">Notemd.cloud</div>
        <div class="SubTitle">
          <span>还没有账户吗？</span>
          <span class="Link" @click="GoToRegister">在此注册</span>
        </div>
      </div>

      <div class="Divider">
        <span>OR</span>
      </div>

      <div class="Form">
        <div class="InputGroup">
          <label>邮箱 / 用户名</label>
          <input 
            v-model="login.data.user" 
            :disabled="login.state"
            class="Input" 
            ref="User"
            data-name="User" 
            :placeholder="login.placeholder.user"
            @focus="login.placeholder.user = defaultInfo.userPlaceholder"
            @keydown.enter="KeydownEnter"/>
        </div>

        <div class="InputGroup">
          <div class="LabelRow">
            <label>密码</label>
            <span class="Link" @click="ShowForgotTip">忘记密码?</span>
          </div>
          <input 
            v-model="login.data.password" 
            :disabled="login.state"
            class="Input" 
            ref="Password" 
            type="password"
            data-name="Password" 
            :placeholder="login.placeholder.password"
            @focus="login.placeholder.password = defaultInfo.passwordPlaceholder"
            @keydown.enter="KeydownEnter"/>
        </div>

        <div class="Controls">
          <label class="Checkbox">
            <input type="checkbox" v-model="login.remember">
            <span>自动登录</span>
          </label>
        </div>

        <button 
          class="SubmitBtn" 
          :class="login.state ? 'Button_Disabled' : ''"
          @click="Login" 
          :disabled="login.state">
          <span>{{ login.state ? '登录中...' : '登 入' }}</span>
        </button>
      </div>
    </div>

    <Dialog v-if="control.dialog.state" :title="control.dialog.title"
      :acceptName="control.dialog.buttonName.accept"
      :cancelName="control.dialog.buttonName.cancel"
      :content="control.dialog.content"
      :icon="control.dialog.icon"
      :accept="control.dialog.accept"
      @dialogCancel="control.dialog.state = false">
      <div v-if="control.dialog.name === 'ResetPwd'" class="ResetPwdForm">
        <input v-model="resetPwd.data.email" class="Input" placeholder="请输入邮箱">
        <div class="CodeRow">
          <input v-model="resetPwd.data.code" class="Input" placeholder="验证码">
          <button class="SendCodeBtn" :disabled="countdown > 0" @click="SendResetCode">
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>
        <input v-model="resetPwd.data.newPwd" type="password" class="Input" placeholder="请输入新密码"
          @keydown.enter="$refs.CheckPwd.focus()">
        <input v-model="resetPwd.data.checkPwd" type="password" class="Input" ref="CheckPwd" placeholder="请再次输入新密码"
          @keydown.enter="SubmitResetPwd">
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/Dialog.vue'
export default {
  components: { Dialog },
  data () {
    return {
      control: {
        title: [],
        dialog: {
          // state: false,
          // title: '登录失败',
          // content: '登录密码错误',
          // icon: '/icon/password.svg',
          // buttonName: { accept: '好的', cancel: '' }
        }
      },
      login: {
        data: { user: this.$cookie.get('userName') || '', password: '' },
        placeholder: {
          user: '请输入用户名',
          password: '请输入密码'
        },
        state: false,
        remember: true
      },
      defaultInfo: { userPlaceholder: '请输入用户名', passwordPlaceholder: '请输入密码' },
      resetPwd: {
        data: { email: '', code: '', newPwd: '', checkPwd: '' },
        state: false
      },
      countdown: 0,
      timer: null
    }
  },
  methods: {
    KeydownEnter: function (event) {
      const inputName = event.currentTarget.dataset.name
      switch (inputName) {
        case 'User':
          this.$refs.Password.focus()
          break
        case 'Password':
          this.Login()
          break
      }
    },
    GoToRegister: function () {
      this.$router.push('/Register')
    },
    ShowForgotTip: function () {
      this.resetPwd.data = { email: '', code: '', newPwd: '', checkPwd: '' }
      this.control.dialog = {
        state: true,
        title: '重置密码',
        name: 'ResetPwd',
        icon: '/icon/password.svg',
        buttonName: { accept: '确认重置', cancel: '取消' },
        accept: () => { this.SubmitResetPwd() }
      }
    },
    SendResetCode: function () {
      const email = this.resetPwd.data.email
      if (!email) {
        this.$Common.ShowToast(this, '请输入邮箱', 'warning')
        return
      }
      if (this.countdown > 0) return

      this.$Common.ApiList(this, 'SendCode').then(url => {
        this.$Common.SetLoading('正在发送验证码...')
        this.axios.get(url, { params: { email }, timeout: 60000 }).then(res => {
          this.$Common.RemoveLoading()
          if (res.data.code === 200) {
            this.StartCountdown()
            this.$Common.ShowToast(this, '验证码已发送', 'success')
          } else {
            this.$Common.ShowToast(this, res.data.message || '发送失败', 'warning')
          }
        }).catch(() => {
          this.$Common.RemoveLoading()
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    StartCountdown: function () {
      this.countdown = 60
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    SubmitResetPwd: function () {
      const { email, code, newPwd, checkPwd } = this.resetPwd.data
      if (!email || !code || !newPwd) {
        this.$Common.ShowToast(this, '请填写完整信息', 'warning')
        return
      }
      if (newPwd !== checkPwd) {
        this.$Common.ShowToast(this, '两次新密码输入不一致', 'warning')
        return
      }
      
      this.$Common.SetLoading('正在重置密码...')
      this.$Common.ApiList(this, 'ChangePwd').then(url => {
        // Backend expects ResetPasswordRequest: { email, password, code }
        const payload = {
          email: email,
          password: newPwd, // Map newPwd to password field
          code: code
        }
        this.axios.post(url, payload).then(res => {
          this.$Common.RemoveLoading()
          if (res.data.code === 200) {
            this.control.dialog.state = false
            this.$Common.ShowToast(this, '重置成功，请使用新密码登录', 'success')
          } else {
            this.$Common.ShowToast(this, res.data.message || '重置失败', 'warning')
          }
        }).catch(() => {
          this.$Common.RemoveLoading()
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    Login: function () {
      const { user, password } = this.login.data
      const { userPlaceholder, passwordPlaceholder } = this.defaultInfo
      var userTips = userPlaceholder
      var passwordTips = passwordPlaceholder

      this.login.state = true
      this.$Common.SetLoading('登录中...')

      // 上传前检验数据
      if (user === '') {
        userTips = '用户名不得为空'
        this.$refs.User.focus()
        this.login.state = false
        this.$Common.RemoveLoading()
      } else if (password === '') {
        passwordTips = '密码不得为空'
        this.$refs.Password.focus()
        this.login.state = false
        this.$Common.RemoveLoading()
      } else {
        // 请求登录
        this.$Common.ApiList(this, 'SignIn').then(url => {
          const payload = { userName: user, password }
          this.axios.post(url, payload).then(res => {
            const resData = res.data
            if (resData.code === 200) {
              // 存储 Token 和 用户名
              if (resData.data && resData.data.token) {
                localStorage.setItem('token', resData.data.token)
                // 根据是否勾选自动登录设置 cookie 有效期
                const days = this.login.remember ? 7 : 1
                this.$cookie.set('userName', resData.data.userName, days)
                this.$cookie.set('nickname', resData.data.nickname || resData.data.userName, days)
              }
              
              this.$router.push('/Index').then(() => {
                this.login.state = false
                this.$Common.RemoveLoading()
              })
            } else {
              this.control.dialog = {
                state: true,
                title: '登录失败',
                content: resData.message || '用户名或密码错误',
                icon: '/icon/warning.svg',
                buttonName: { accept: '朕知道了' },
                accept: () => { this.control.dialog.state = false }
              }
              this.login.state = false
              this.$Common.RemoveLoading()
            }
          }).catch(() => {
            this.$Common.NetworkErrorDialog(this)
            this.login.state = false
          })
        })
      }
      this.login.placeholder = { user: userTips, password: passwordTips }
    }
  },
  mounted () {
    this.$Common.SetLoading('正在加载组件, 请稍候...')
    this.$Common.SetDocTitle(this)
    this.$refs.User.focus()
    this.$Common.RemoveLoading()
  }
}
</script>

<style scoped>
  .LoginContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 背景占位，后续替换为图片 */
    background: #f0f2f5 url('/picture/LoginIndexBackGround.webp') no-repeat center center;
    background-size: cover;
  }

  .LoginCard {
    width: 400px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .Header {
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
  }

  .Title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }

  .SubTitle {
    font-size: 14px;
    color: #666;
  }

  .Link {
    color: #409eff;
    cursor: pointer;
    margin-left: 5px;
    font-weight: 500;
  }

  .Link:hover {
    text-decoration: underline;
  }

  .Divider {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #eee;
    line-height: 0.1em;
    margin: 20px 0 30px;
  }

  .Divider span {
    background: #fff;
    padding: 0 10px;
    color: #999;
    font-size: 12px;
  }

  .Form {
    width: 100%;
  }

  .InputGroup {
    margin-bottom: 20px;
  }

  .InputGroup label {
    display: block;
    font-size: 12px;
    color: #333;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .LabelRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .LabelRow label {
    margin-bottom: 0;
  }

  .Input {
    width: 100%;
    height: 40px;
    border: 1px solid #dcdfe6;
    background: #f4f6f8;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
  }

  .Input:focus {
    border-color: #409eff;
    background: #fff;
    outline: none;
  }

  .Controls {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
  }

  .Checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 13px;
    color: #606266;
  }

  .Checkbox input {
    margin-right: 8px;
  }

  .SubmitBtn {
    width: 100%;
    height: 40px;
    background: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
  }

  .SubmitBtn:hover {
    background: #66b1ff;
  }

  .SubmitBtn:active {
    background: #3a8ee6;
  }

  .Button_Disabled {
    background: #a0cfff;
    cursor: not-allowed;
  }

  .ResetPwdForm {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .CodeRow {
    display: flex;
    gap: 10px;
  }
  
  .CodeRow .Input {
    flex: 1;
  }

  .SendCodeBtn {
    padding: 0 15px;
    background: #409eff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.3s, opacity 0.3s;
    white-space: nowrap;
  }
  
  .SendCodeBtn:hover {
    background: #66b1ff;
  }
  
  .SendCodeBtn:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
</style>
